import { render, staticRenderFns } from "./Cotton.vue?vue&type=template&id=f14fa19a&scoped=true&"
import script from "./Cotton.vue?vue&type=script&lang=js&"
export * from "./Cotton.vue?vue&type=script&lang=js&"
import style0 from "./Cotton.vue?vue&type=style&index=0&id=f14fa19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14fa19a",
  null
  
)

export default component.exports